import { LocationDescriptor } from 'history';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

type NavigateFunction = {
  (to: LocationDescriptor, options?: { replace?: boolean; state?: any }): void;
  (delta: number): void;
};

const useNavigate = (): NavigateFunction => {
  const history = useHistory();
  return useCallback((toOrDelta: any, options: any = {}) => {
    if (typeof toOrDelta === 'number') {
      history.go(toOrDelta);
    } else {
      const { replace, state } = options;

      history[replace ? 'replace' : 'push'](toOrDelta, state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default useNavigate;
